<section class="panel">
  @if (errorMessage(); as message) {
    <p class="error" role="alert">{{ message }}</p>
  }

  @switch (view()) {
    @case ('list') {
      <div class="head">
        <h2>Help and feedback</h2>
        <button tuiButton size="s" type="button" (click)="startNew()">New request</button>
      </div>
      @if (loading()) {
        <p class="muted">Loading...</p>
      } @else if (!threads().length) {
        <p class="muted">No requests yet. Tell us about a problem or an idea.</p>
      } @else {
        <ul class="threads">
          @for (t of threads(); track t.id) {
            <li>
              <button type="button" class="thread-row" (click)="openThread(t.id)">
                @if (t.user_unread) {
                  <span class="unread" aria-label="Unread reply"></span>
                }
                <span class="subject">{{ t.subject }}</span>
                <span class="chip" [attr.data-status]="t.status">{{ t.status }}</span>
              </button>
            </li>
          }
        </ul>
      }
    }

    @case ('new') {
      <div class="head">
        <h2>New request</h2>
        <button tuiButton size="s" appearance="flat" type="button" (click)="showList()">Back</button>
      </div>
      <form [formGroup]="newForm" (ngSubmit)="submitNew()" class="form">
        <div class="kinds" role="radiogroup" aria-label="Request type">
          @for (k of kinds; track k.value) {
            <button
              type="button"
              role="radio"
              class="kind"
              [class.active]="newForm.controls.kind.value === k.value"
              [attr.aria-checked]="newForm.controls.kind.value === k.value"
              (click)="setKind(k.value)"
            >
              {{ k.label }}
            </button>
          }
        </div>
        <label class="field">
          <span>Subject</span>
          <input type="text" formControlName="subject" [maxLength]="subjectMax" />
        </label>
        <label class="field">
          <span>Message</span>
          <textarea formControlName="body" rows="6" [maxLength]="bodyMax"></textarea>
        </label>
        <app-screenshot-picker [(files)]="files" />
        <p class="muted">We'll include: {{ pagePath }}, your browser</p>
        <button tuiButton type="submit" [disabled]="newForm.invalid || sending()">Send</button>
      </form>
    }

    @case ('thread') {
      @if (thread(); as t) {
        <div class="head">
          <h2>{{ t.subject }}</h2>
          <button tuiButton size="s" appearance="flat" type="button" (click)="showList()">Back</button>
        </div>
        <span class="chip" [attr.data-status]="t.status">{{ t.status }}</span>
        <ul class="messages">
          @for (m of t.messages; track m.id) {
            <li class="message" [class.staff]="isStaff(m)">
              <div class="meta">
                <strong>{{ isStaff(m) ? 'Support' : 'You' }}</strong>
                <span class="muted">{{ m.created_at | date: 'short' }}</span>
              </div>
              <p class="body">{{ m.body }}</p>
              @if (m.attachments.length) {
                <div class="attachments">
                  @for (a of m.attachments; track a.id) {
                    <a [href]="attachmentUrl(a)" target="_blank" rel="noopener noreferrer">
                      <img [src]="attachmentUrl(a)" alt="Attachment" loading="lazy" />
                    </a>
                  }
                </div>
              }
            </li>
          }
        </ul>
        <form [formGroup]="replyForm" (ngSubmit)="submitReply()" class="form">
            <label class="field">
              <span>Reply</span>
              <textarea formControlName="body" rows="3" [maxLength]="bodyMax"></textarea>
            </label>
            <app-screenshot-picker [(files)]="files" />
            <div class="actions">
              <button tuiButton type="submit" [disabled]="replyForm.invalid || sending()">Send</button>
              @if (t.status !== 'closed') {
                <button tuiButton appearance="secondary" type="button" (click)="closeThread()">Close</button>
              }
            </div>
          </form>
      }
    }
  }
</section>
